export const SESSION_CHECK_REQUESTED = 'achiezer:check-session'

export const isUnauthorized = error => !!(error && error.response && error.response.status === 401)

export const requestSessionCheck = error => {
    const response = error && error.response
    if (isUnauthorized(error) || (response && response.status === 403 && response.data && response.data.message === 'Invalid CSRF token')) {
        window.dispatchEvent(new Event(SESSION_CHECK_REQUESTED))
    }
}
